import { Button, Dialog, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { ServiceModifier } from './ServiceModifier';

const useStyles = makeStyles(theme => ({
}));
const ServiceModifierDialog = ({
  booking,
  readOnly,
  promo,
  services,
  onSetServices = (serviceArray) => { },
  selectedServices,
  displayCoverage
}) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false);

  const [service, setService] = useState(null);

  if (readOnly || !booking.is_whitelabel ) {
    return null
  }
  return (
    <>
      <Button variant="contained" color="secondary" onClick={() => setIsOpen(true)}>Add/Remove Services</Button>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>
          Add/Remove Services
        </DialogTitle>
          <ServiceModifier
            booking={booking}
            promo={promo}
            displayCoverage={displayCoverage}
            open={isOpen}
            onClose={()=>setIsOpen(false)}
            services={services}
            selectedServices={selectedServices}
            onSetServices={onSetServices}
          />
      </Dialog>
    </>
  )
}

export { ServiceModifierDialog }